import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fetchVimeoOembedData } from '../utils/vimeo';
import PlayIcon from './PlayIcon';


class Thumbnail extends Component {
  constructor (props) {
    super(props);
    this.state = {
      vimeoImage: null,
    };
  }

  componentDidMount () {
    const { vimeoUrl, image } = this.props;
    if (vimeoUrl && !image) {
      this.fetchData();
    }
  }

  fetchData () {
    const { vimeoUrl } = this.props;
    fetchVimeoOembedData(vimeoUrl, 1280).then(data => {
      this.setState({ vimeoImage: data.thumbnailUrl });
    });
  }

  render () {
    const { image, playIcon, aspectRatio } = this.props;
    const { vimeoImage } = this.state;
    const [ w, h ] = aspectRatio.split(/[:/x]/);
    const containerStyles = {
      paddingBottom: `${h / w * 100}%`,
    };
    const backgroundImageUrl = image || vimeoImage || null;
    const elStyles = {
      backgroundColor: '#e6e6e6',
      backgroundImage: backgroundImageUrl ? `url('${backgroundImageUrl}')` : null,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
    };

    return (
      <div className="ar-16-9" style={containerStyles}>
        <div style={elStyles} />
        {playIcon ? <PlayIcon thumbnail /> : null }
      </div>
    );
  }
}

Thumbnail.propTypes = {
  image: PropTypes.string,
  vimeoUrl: PropTypes.string,
  aspectRatio: PropTypes.string,
  playIcon: PropTypes.bool,
};

Thumbnail.defaultProps = {
  aspectRatio: '16:9',
  playIcon: true,
};

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/components/Thumbnail.js